import * as initialMoment from "moment"
import DateGroupedStatementItems from "@irati/wallet/types/DateGroupedStatementItems"
import DateGroupedScheduledTransfers from "@irati/wallet/types/DateGroupedScheduledTransfers"

/**
 * Hack
 * Getting moment to play nicely with typescript, tests AND react-native is problematic
 * This is the only way i've found so far to get it working. Solution from:
 * https://github.com/palantir/blueprint/issues/959#issuecomment-335965129
 */
// @ts-ignore

const moment = initialMoment.default || initialMoment

export default function groupWalletItemsByDate(
  walletItems: DateGroupedStatementItems[] | DateGroupedScheduledTransfers[],
  results: StatementItem[] | ScheduledTransfer[]) {
  const existing = [...walletItems]
  results.forEach((result) => {
    const createdAt = result.createdAt? result.createdAt : result.transfer.createdAt
    const resultDate = moment(createdAt).startOf("day")
    const lastExistingDay = existing[existing.length - 1]
    if (lastExistingDay && resultDate.isSame(lastExistingDay.date.startOf("day"))) {
      lastExistingDay.data.push(result)
    } else {
      existing.push(
        {
          date: moment(createdAt).startOf("day"),
          data: [result]
        }
      )
    }
  })

  return {
    results: existing
  }
}
